import { CardElement } from "@stripe/react-stripe-js";

interface StripeCardProps {
  onChange: () => void;
  errorMessage: string | null;
}

export const StripeCard = ({ onChange, errorMessage }: StripeCardProps) => (
  <section className="flex flex-col gap-4 rounded border border-gray-300 bg-white p-3">
    <h3 className="m-0 p-0 text-left font-semibold text-base text-gray-800">
      Credit Card or debit card
    </h3>
    <div className="rounded border border-gray-300 p-1.5">
      <CardElement
        onChange={onChange}
        options={{
          style: {
            base: {
              fontSize: "16px",
              fontWeight: "500",
            },
          },
        }}
      />
    </div>
    {errorMessage && (
      <p className="m-0 p-0 text-red-500 text-sm">{errorMessage}</p>
    )}
  </section>
);
